/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { InitalStateInterface, MembersRequest } from './types';

export const MEMBERS_INITIAL_STATE: InitalStateInterface = {
  data: null,
  fetching: false,
  payload: [],
  memberSelected: null,
  errors: [],
  totalCount: 0,
  page: 1,
};

const membersSlice = createSlice({
  name: 'members',
  initialState: MEMBERS_INITIAL_STATE,
  reducers: {
    membersRequest: (state, _action: PayloadAction<MembersRequest>) => {
      state.fetching = true;
      state.payload = [];
      state.memberSelected = null;
    },
    membersSuccess: (state, action: PayloadAction<any>) => {
      state.fetching = false;
      state.errors = [];
      state.payload = action.payload;
    },
    membersFailure: (state, action: PayloadAction<any>) => {
      state.fetching = false;
      state.errors = action.payload;
      state.payload = [];
    },
    setMembersTotalCount: (state, action: PayloadAction<number>) => {
      state.totalCount = action.payload;
    },
    setMembersPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    getMember: (state, _action: PayloadAction<{ id: string }>) => {
      state.fetching = true;
      state.errors = [];
      state.memberSelected = null;
    },
    getMemberSuccess: (state, action: PayloadAction<any>) => {
      state.fetching = false;
      state.errors = [];
      state.memberSelected = action.payload;
    },
    setMemberIsActiveRequest: (
      _state,
      _action: PayloadAction<{ memberId: string; isActive: boolean }>,
    ) => {},
    setRegistrationMemberRequest: (state, _action: PayloadAction<any>) => {
      state.fetching = true;
    },
  },
});

export const {
  membersRequest,
  membersSuccess,
  membersFailure,
  setMembersTotalCount,
  setMembersPage,
  getMember,
  getMemberSuccess,
  setMemberIsActiveRequest,
  setRegistrationMemberRequest,
} = membersSlice.actions;

export const membersReducer = membersSlice.reducer;
